// NULA — aparición suave de elementos al hacer scroll
(function () {
  function init() {
    var els = document.querySelectorAll('.nula-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  // Alto de la barra negra fija, para ubicar el header justo debajo
  function medirBarra() {
    var barra = document.querySelector('.announcement-bar-section');
    document.documentElement.style.setProperty('--nula-bar-h', (barra ? barra.offsetHeight : 0) + 'px');
  }

  // ---------------------------------------------------------
  // Opciones de color ("Combinación"): el cliente tiene que elegir una.
  // Al entrar sin ?variant= en la dirección, ninguna queda marcada.
  // ---------------------------------------------------------
  // Grupos de opciones que el cliente tiene que elegir sí o sí: colores (círculos) y botones (Modelo, Talle…)
  var GRUPO = '.product-form__input--nula-duo, .product-form__input--pill, .product-form__input--swatch';

  function textoElegido(grupo, texto) {
    var span = grupo.querySelector('[data-selected-value]');
    if (!span) {
      var leyenda = grupo.querySelector('legend');
      if (!leyenda) return;
      leyenda.insertAdjacentHTML('beforeend', ': <span class="nula-duo-elegido" data-selected-value></span>');
      span = leyenda.querySelector('[data-selected-value]');
    }
    span.textContent = texto;
  }

  function desmarcarAlEntrar() {
    if (/[?&]variant=/.test(window.location.search)) return;
    document.querySelectorAll(GRUPO).forEach(function (grupo) {
      grupo.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      textoElegido(grupo, 'Elegí una opción');
    });
  }

  function mostrarAviso(grupo) {
    var aviso = grupo.querySelector('.nula-aviso-opcion');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = 'nula-aviso-opcion';
      aviso.setAttribute('role', 'alert');
      grupo.appendChild(aviso);
    }
    var nombre = (grupo.querySelector('legend') || {}).firstChild;
    nombre = nombre ? nombre.textContent.replace(':', '').trim().toLowerCase() : '';
    var frase = 'una opción';
    if (/^colou?r(es)?$/.test(nombre) || /^tonos?$/.test(nombre)) frase = 'un color';
    else if (nombre.indexOf('combinaci') === 0) frase = 'una combinación';
    else if (/^tall(e|a)s?$/.test(nombre)) frase = 'un talle';
    else if (nombre.indexOf('modelo') === 0) frase = 'un modelo';
    aviso.textContent = 'Elegí ' + frase + ' para continuar';
    requestAnimationFrame(function () { aviso.classList.add('is-visible'); });
    grupo.classList.remove('nula-sacudir');
    void grupo.offsetWidth;
    grupo.classList.add('nula-sacudir');
    var arriba = grupo.getBoundingClientRect().top;
    if (arriba < 120 || arriba > window.innerHeight - 120) {
      grupo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function faltaElegir(desde) {
    var ficha = desde.closest('product-info') || document;
    var grupos = ficha.querySelectorAll(GRUPO);
    for (var i = 0; i < grupos.length; i++) {
      if (!grupos[i].querySelector('input[type="radio"]:checked')) return grupos[i];
    }
    return null;
  }

  // Se escucha en fase de captura para frenar el envío antes que el tema
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var grupo = faltaElegir(form);
    if (grupo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      mostrarAviso(grupo);
    }
  }, true);

  // "Comprar ahora" (botón de Shopify): también exige elegir la opción
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('.shopify-payment-button__button, .shopify-payment-button button');
    if (!boton) return;
    var grupo = faltaElegir(boton);
    if (grupo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      mostrarAviso(grupo);
    }
  }, true);

  // Botón propio "Comprar ahora": agrega el producto elegido y va directo al checkout
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('[data-nula-comprar-ahora]');
    if (!boton) return;
    e.preventDefault();
    var grupo = faltaElegir(boton);
    if (grupo) { mostrarAviso(grupo); return; }
    var ficha = boton.closest('product-info') || document;
    var form = ficha.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var cant = ficha.querySelector('input[name="quantity"]');
    boton.setAttribute('aria-busy', 'true');
    boton.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id.value), quantity: cant ? Number(cant.value) || 1 : 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('No se pudo agregar');
      window.location.href = '/checkout';
    }).catch(function () {
      boton.disabled = false;
      boton.removeAttribute('aria-busy');
      if (form && form.requestSubmit) form.requestSubmit();
    });
  });

  // Al elegir, se oculta el aviso
  document.addEventListener('change', function (e) {
    var grupo = e.target.closest && e.target.closest(GRUPO);
    if (!grupo) return;
    var aviso = grupo.querySelector('.nula-aviso-opcion');
    if (aviso) aviso.classList.remove('is-visible');
  });

  // ---------------------------------------------------------
  // Flechitas sobre la foto principal del producto (compu y celular)
  // ---------------------------------------------------------
  var FLECHA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function visibles(lista) {
    return Array.prototype.filter.call(lista, function (el) {
      return getComputedStyle(el).display !== 'none' && !el.classList.contains('product__media-item--variant');
    });
  }

  function moverGaleria(visor, paso) {
    var galeria = visor.closest('media-gallery') || document;
    var miniaturas = galeria.querySelector('.thumbnail-list');
    // Compu: usa las miniaturas
    if (miniaturas && miniaturas.offsetParent !== null) {
      var botones = visibles(miniaturas.querySelectorAll('.thumbnail-list__item')).map(function (li) { return li.querySelector('button'); });
      var actual = botones.findIndex(function (b) { return b && b.hasAttribute('aria-current'); });
      var sig = botones[(actual + paso + botones.length) % botones.length];
      if (sig) sig.click();
      setTimeout(function () { ubicarFlechas(visor); }, 60);
      return;
    }
    // Celular: desliza la galería
    var lista = visor.querySelector('.product__media-list');
    var items = visibles(lista.querySelectorAll('.product__media-item'));
    if (!items.length) return;
    var ancho = items[0].getBoundingClientRect().width;
    var idx = Math.round(lista.scrollLeft / ancho);
    var destino = (idx + paso + items.length) % items.length;
    lista.scrollTo({ left: items[destino].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
  }

  // En la compu la foto queda centrada y más angosta que el contenedor:
  // las flechas se ubican sobre la foto visible, no sobre los bordes del contenedor.
  function ubicarFlechas(visor) {
    var cont = visor.querySelector('.nula-flechas');
    if (!cont) return;
    var galeria = visor.closest('media-gallery') || document;
    var miniaturas = galeria.querySelector('.thumbnail-list');
    var foto = visor.querySelector('.product__media-item.is-active .media');
    if (miniaturas && miniaturas.offsetParent !== null && foto) {
      var rv = visor.getBoundingClientRect();
      var rf = foto.getBoundingClientRect();
      cont.style.left = (rf.left - rv.left) + 'px';
      cont.style.top = (rf.top - rv.top) + 'px';
      cont.style.width = rf.width + 'px';
      cont.style.height = rf.height + 'px';
      cont.style.right = cont.style.bottom = 'auto';
    } else {
      cont.removeAttribute('style');
    }
  }

  function ponerFlechas() {
    document.querySelectorAll('media-gallery slider-component[id^="GalleryViewer"]').forEach(function (visor) {
      // Se cuentan todas las fotos (en la compu el tema oculta las que no están activas)
      var items = Array.prototype.filter.call(visor.querySelectorAll('.product__media-item'), function (el) {
        return !el.classList.contains('product__media-item--variant');
      });
      var existentes = visor.querySelector('.nula-flechas');
      if (items.length < 2) { if (existentes) existentes.remove(); return; }
      if (existentes) { ubicarFlechas(visor); return; }
      var cont = document.createElement('div');
      cont.className = 'nula-flechas';
      cont.innerHTML =
        '<button type="button" class="nula-flecha nula-flecha--prev" aria-label="Foto anterior">' + FLECHA + '</button>' +
        '<button type="button" class="nula-flecha nula-flecha--next" aria-label="Foto siguiente">' + FLECHA + '</button>';
      cont.querySelector('.nula-flecha--prev').addEventListener('click', function () { moverGaleria(visor, -1); });
      cont.querySelector('.nula-flecha--next').addEventListener('click', function () { moverGaleria(visor, 1); });
      visor.appendChild(cont);
      ubicarFlechas(visor);
      visor.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { ubicarFlechas(visor); }, { once: true });
      });
    });
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('media-gallery slider-component[id^="GalleryViewer"]').forEach(ubicarFlechas);
  });

  // El tema vuelve a dibujar la galería al cambiar de variante: se reponen las flechas
  var reponer;
  new MutationObserver(function () {
    clearTimeout(reponer);
    reponer = setTimeout(ponerFlechas, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { init(); medirBarra(); desmarcarAlEntrar(); ponerFlechas(); });
  window.addEventListener('resize', medirBarra);
  window.addEventListener('load', medirBarra);
  // Editor de temas: re-inicializar al editar secciones
  document.addEventListener('shopify:section:load', function () { init(); medirBarra(); });
})();
